import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import CriteriaModal from '../containers/CriteriaModal';

const CriteriaModalWrapper = ({ isOpen, close, reportId }) => (
  <Modal
    isOpen={isOpen}
    toggle={close}
    centered
    contentClassName="CriteriaModal_wrapper"
    backdropClassName="CriteriaModal_background"
  >
    <CriteriaModal closeModal={close} reportId={reportId} />
  </Modal>
);

CriteriaModalWrapper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  reportId: PropTypes.string,
};

CriteriaModalWrapper.defaultProps = {
  reportId: null,
};

export default CriteriaModalWrapper;
